import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import useFormatter from '@hooks/useFormatter';
import useLoading from '@hooks/useLoading';
import { IDataRequest } from '@hooks/useRequest';
import { useValueState } from '@hooks/useValueState';
import { Box, Card, CardHeader, CardContent, CircularProgress, Typography } from '@material-ui/core';
import { IDespesaFilter, IDespesaSummary, useDespesaService } from '@services/DespesaService';
import { noop } from '@utils/Functions';
import React from 'react';

export type DespesaSummaryProps = {
    requestedData: IDataRequest<IDespesaFilter>
}

export function DespesaSummary ({ requestedData }: DespesaSummaryProps) {
    const formatter = useFormatter();
    const loading = useLoading();
    const summaryData = useValueState<IDespesaSummary>();
    const despesaService = useDespesaService();
    
    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            despesaService.obterSumario(requestedData)
                .then(summaryData.handleResponse)
                .catch(noop)
                .finally(loading.stop);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestedData]);

    return (
        <Box style={{marginTop: 24, marginBottom: 24}}>
            <HorizontalGrid spacing={2}>
                <GridItem xs={6}>
                    <Card elevation={15}>
                        <CardHeader title="Total de Despesas" />
                        <CardContent>
                            {
                                loading.isLoading
                                ? <Box style={{textAlign: 'center'}}><CircularProgress /></Box>
                                : <Typography variant="h3">{summaryData.value?.count || ""}</Typography>
                            }
                        </CardContent>
                    </Card>
                </GridItem>
                
                <GridItem xs={6}>
                    <Card elevation={15}>
                        <CardHeader title="Valor Total" />
                        <CardContent>
                            {
                                loading.isLoading
                                ? <Box style={{textAlign: 'center'}}><CircularProgress /></Box>
                                : <Typography variant="h3">{formatter.toFloat(summaryData.value?.sumValor) || ""}</Typography>
                            }
                        </CardContent>
                    </Card>
                </GridItem>
            </HorizontalGrid>
        </Box>
    )
}